import SEO from "@/components/SEO";

const HERO_IMG = "https://images.unsplash.com/photo-1593382067395-ace3045a1547?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  return (
    <>
      <SEO title="Hakkımızda — Wünberg Markası" description="Wünberg Paint & Coating: Avrupa kalite standartlarında premium akrilik hobi boyalarının hikayesi." />
      <section className="pt-32 pb-12 border-b border-white/10">
        <div className="wb-container">
          <div className="wb-overline">Hakkımızda</div>
          <h1 className="wb-h1 mt-3">Renge duyulan saygı, <span className="italic text-[#d4af37]">şişeden</span> tuvale.</h1>
        </div>
      </section>

      <section className="wb-section">
        <div className="wb-container grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <img src={HERO_IMG} alt="" className="w-full h-[600px] object-cover" />
          <div>
            <div className="wb-overline">Misyonumuz</div>
            <h2 className="wb-h2 mt-3">Sanatçının vizyonu ile tuval arasındaki köprü.</h2>
            <p className="wb-body mt-6">
              Wünberg, Avrupa boya geleneğinin titizliğini Anadolu sanatkârlığının
              hassasiyetiyle birleştirir. Her renk; ressamların atölye masasında
              hissedeceği derinliği yansıtmak üzere laboratuvarımızda saf pigmentlerden
              formüle edilir.
            </p>
            <p className="wb-body mt-4">
              Hobi tutkunlarından profesyonel sanatçılara — boyamızı kullanan herkesin
              vizyonunu sınırsız renk yelpazesi, üst düzey kalıcılık ve sertifikalı
              güvenlikle desteklemek için varız.
            </p>
          </div>
        </div>
      </section>

      <section className="wb-section bg-[#020a1a]">
        <div className="wb-container">
          <div className="wb-overline">Değerlerimiz</div>
          <h2 className="wb-h2 mt-3 max-w-2xl">Premium, ulaşılabilir olmalı.</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {[
              { t: "Kalite", d: "Her partide bağımsız test, sıfır taviz. EN 71-3 ve REACH uyumlu." },
              { t: "Şeffaflık", d: "Formülasyonlarımızda kullanılan tüm pigmentler etiketlerimizde açıkça belirtilir." },
              { t: "Sanat", d: "Boyamız bir araçtır, sanatçı baştır. Ürünlerimizi sanatkâr geri bildirimi ile geliştiriyoruz." },
            ].map((v) => (
              <div key={v.t} className="wb-card p-8">
                <div className="font-serif text-2xl text-[#d4af37]">0{["Kalite","Şeffaflık","Sanat"].indexOf(v.t)+1}</div>
                <div className="font-serif text-xl mt-3">{v.t}</div>
                <p className="text-sm text-[#a0aabf] mt-2 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="wb-section">
        <div className="wb-container">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { v: "120+", l: "Renk Tonu" },
              { v: "%40", l: "Pigment Yoğunluğu" },
              { v: "10 Yıl", l: "Solmaz Garanti" },
              { v: "100%", l: "Çevre Dostu" },
            ].map((s) => (
              <div key={s.l} className="text-center md:text-left">
                <div className="font-serif text-4xl md:text-5xl text-[#d4af37]">{s.v}</div>
                <div className="text-xs uppercase tracking-widest text-[#a0aabf] mt-2">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-32">
        <div className="wb-container">
          <div className="wb-card p-8 md:p-12 grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div>
              <div className="wb-overline">Kurumsal</div>
              <h3 className="font-serif text-2xl mt-3 leading-snug">
                Çebi Havacılık Turizm Org. Bil. Teks. İnş. Res. Oto Eml. San. ve Tic. Ltd. Şti.
              </h3>
              <p className="text-sm text-[#a0aabf] mt-4">
                Wünberg markası, Çebi Havacılık bünyesinde Türkiye genelinde akrilik
                hobi boyası üretim ve dağıtım faaliyetlerini sürdürmektedir.
              </p>
            </div>

            <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
              <div>
                <div className="wb-overline text-[10px]">Vergi Bilgileri</div>
                <div className="mt-3 space-y-1.5">
                  <div className="text-[#a0aabf]">Vergi Dairesi</div>
                  <div className="text-[#fdfbf7]">Antalya Kurumlar VD</div>
                  <div className="text-[#a0aabf] mt-3">Vergi Numarası</div>
                  <div className="text-[#fdfbf7] font-mono">2330655311</div>
                </div>
              </div>
              <div>
                <div className="wb-overline text-[10px]">Adres</div>
                <div className="mt-3 text-[#fdfbf7] leading-relaxed">
                  Yeşilbahçe Mah.<br />
                  1428 Sokak No: 48/A<br />
                  Muratpaşa / ANTALYA
                </div>
                <div className="mt-4 text-[#a0aabf]">
                  <a href="tel:+905442226107" className="hover:text-[#d4af37]">+90 544 222 6 1 07</a><br />
                  <a href="mailto:info@cebitech.com.tr" className="hover:text-[#d4af37]">info@cebitech.com.tr</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
